import type { MaterialView, PublicSectionView, SectionImageView } from '@/api/types';

const BYTES_PER_UNIT = 1024;
const DECIMAL_PLACES = 1;
const SIZE_UNITS = ['B', 'KB', 'MB', 'GB'] as const;

export function hasText(value: string | null | undefined): boolean {
  return typeof value === 'string' && value.trim().length > 0;
}

export function optionalText(value: string | null | undefined): string {
  if (typeof value !== 'string') {
    return '';
  }
  return value.trim();
}

export function sectionImages(section: PublicSectionView): readonly SectionImageView[] {
  if (Array.isArray(section.images)) {
    return section.images;
  }
  // eslint-disable-next-line no-console
  console.error(`[Section] invalid images for section "${section.id}"`);
  return [];
}

export function sectionMaterials(section: PublicSectionView): readonly MaterialView[] {
  if (Array.isArray(section.materials)) {
    return section.materials;
  }
  // eslint-disable-next-line no-console
  console.error(`[Section] invalid materials for section "${section.id}"`);
  return [];
}

export function posterFor(section: PublicSectionView): string | undefined {
  return optionalText(section.posterUrl) || optionalText(section.cover) || undefined;
}

export function formatBytes(sizeBytes: number): string {
  if (!Number.isFinite(sizeBytes) || sizeBytes < 0) {
    // eslint-disable-next-line no-console
    console.error(`[Material] invalid sizeBytes: ${String(sizeBytes)}`);
    return '';
  }

  let value = sizeBytes;
  let unitIndex = 0;
  while (value >= BYTES_PER_UNIT && unitIndex < SIZE_UNITS.length - 1) {
    value /= BYTES_PER_UNIT;
    unitIndex += 1;
  }

  const formatted = unitIndex === 0 ? String(value) : value.toFixed(DECIMAL_PLACES);
  return `${formatted} ${SIZE_UNITS[unitIndex]}`;
}
